import { TimeFilterType } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { generateConsecutiveDateLabels } from '../helpers';

const dates = generateConsecutiveDateLabels(30);

export const dailyData = {
  data: [
    {
      name: dates[0],
      aggValue: 4,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[1],
      aggValue: 3,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[2],
      aggValue: 7,
      values: [
        {
          key: 'SCHEDULE',
          value: '5',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[3],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[4],
      aggValue: 9,
      values: [
        {
          key: 'SCHEDULE',
          value: '7',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '2',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[5],
      aggValue: 2,
      values: [
        {
          key: 'SCHEDULE',
          value: '0',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '2',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[6],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[7],
      aggValue: 4,
      values: [
        {
          key: 'SCHEDULE',
          value: '4',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[8],
      aggValue: 4,
      values: [
        {
          key: 'SCHEDULE',
          value: '3',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[9],
      aggValue: 1,
      values: [
        {
          key: 'SCHEDULE',
          value: '1',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[10],
      aggValue: 2,
      values: [
        {
          key: 'SCHEDULE',
          value: '1',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[11],
      aggValue: 2,
      values: [
        {
          key: 'SCHEDULE',
          value: '1',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[12],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[13],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[14],
      aggValue: 3,
      values: [
        {
          key: 'SCHEDULE',
          value: '3',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[15],
      aggValue: 4,
      values: [
        {
          key: 'SCHEDULE',
          value: '4',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[16],
      aggValue: 2,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[17],
      aggValue: 4,
      values: [
        {
          key: 'SCHEDULE',
          value: '3',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[18],
      aggValue: 3,
      values: [
        {
          key: 'SCHEDULE',
          value: '3',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[19],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[20],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[21],
      aggValue: 6,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '2',
        },
        {
          key: 'CONFIRM',
          value: '2',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[22],
      aggValue: 3,
      values: [
        {
          key: 'SCHEDULE',
          value: '3',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[23],
      aggValue: 6,
      values: [
        {
          key: 'SCHEDULE',
          value: '4',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[24],
      aggValue: 1,
      values: [
        {
          key: 'SCHEDULE',
          value: '1',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[25],
      aggValue: 3,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[26],
      aggValue: 1,
      values: [
        {
          key: 'SCHEDULE',
          value: '0',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[27],
      aggValue: 0,
      values: [],
    },
    {
      name: dates[28],
      aggValue: 2,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: dates[29],
      aggValue: 1,
      values: [
        {
          key: 'SCHEDULE',
          value: '0',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: dates[0],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[1],
      count: 1,
      total: 3,
      average: 3,
    },
    {
      name: dates[2],
      count: 1,
      total: 7,
      average: 7,
    },
    {
      name: dates[4],
      count: 1,
      total: 9,
      average: 9,
    },
    {
      name: dates[5],
      count: 1,
      total: 2,
      average: 2,
    },
    {
      name: dates[7],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[8],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[9],
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: dates[10],
      count: 1,
      total: 2,
      average: 2,
    },
    {
      name: dates[11],
      count: 1,
      total: 2,
      average: 2,
    },
    {
      name: dates[14],
      count: 1,
      total: 3,
      average: 3,
    },
    {
      name: dates[15],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[16],
      count: 1,
      total: 2,
      average: 2,
    },
    {
      name: dates[17],
      count: 1,
      total: 4,
      average: 4,
    },
    {
      name: dates[18],
      count: 1,
      total: 3,
      average: 3,
    },
    {
      name: dates[21],
      count: 1,
      total: 6,
      average: 6,
    },
    {
      name: dates[22],
      count: 1,
      total: 3,
      average: 3,
    },
    {
      name: dates[23],
      count: 1,
      total: 6,
      average: 6,
    },
    {
      name: dates[24],
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: dates[25],
      count: 1,
      total: 3,
      average: 3,
    },
    {
      name: dates[26],
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: dates[28],
      count: 1,
      total: 2,
      average: 2,
    },
    {
      name: dates[29],
      count: 1,
      total: 1,
      average: 1,
    },
  ],
};

export const dayOfWeekData = {
  data: [
    {
      name: 'Monday',
      aggValue: 19,
      values: [
        {
          key: 'SCHEDULE',
          value: '13',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '2',
        },
        {
          key: 'CONFIRM',
          value: '3',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: 'Tuesday',
      aggValue: 15,
      values: [
        {
          key: 'SCHEDULE',
          value: '12',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: 'Wednesday',
      aggValue: 16,
      values: [
        {
          key: 'SCHEDULE',
          value: '12',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '2',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: 'Thursday',
      aggValue: 7,
      values: [
        {
          key: 'SCHEDULE',
          value: '5',
        },
        {
          key: 'RESCHEDULE',
          value: '2',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: 'Friday',
      aggValue: 17,
      values: [
        {
          key: 'SCHEDULE',
          value: '13',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '3',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: 'Saturday',
      aggValue: 3,
      values: [
        {
          key: 'SCHEDULE',
          value: '0',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '3',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: 'Sunday',
      aggValue: 0,
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: 'Monday',
      count: 5,
      total: 19,
      average: 3,
    },
    {
      name: 'Tuesday',
      count: 5,
      total: 15,
      average: 3,
    },
    {
      name: 'Wednesday',
      count: 4,
      total: 16,
      average: 4,
    },
    {
      name: 'Thursday',
      count: 3,
      total: 7,
      average: 2,
    },
    {
      name: 'Friday',
      count: 4,
      total: 17,
      average: 4,
    },
    {
      name: 'Saturday',
      count: 2,
      total: 3,
      average: 1,
    },
    {
      name: 'Sunday',
      count: 0,
      total: 0,
      average: 0,
    },
  ],
};

export const hourlyData = {
  data: [
    {
      name: '0',
      aggValue: 0,
      values: [],
    },
    {
      name: '1',
      aggValue: 0,
      values: [],
    },
    {
      name: '2',
      aggValue: 0,
      values: [],
    },
    {
      name: '3',
      aggValue: 0,
      values: [],
    },
    {
      name: '4',
      aggValue: 0,
      values: [],
    },
    {
      name: '5',
      aggValue: 0,
      values: [],
    },
    {
      name: '6',
      aggValue: 0,
      values: [],
    },
    {
      name: '7',
      aggValue: 0,
      values: [],
    },
    {
      name: '8',
      aggValue: 0,
      values: [],
    },
    {
      name: '9',
      aggValue: 8,
      values: [
        {
          key: 'SCHEDULE',
          value: '6',
        },
        {
          key: 'RESCHEDULE',
          value: '2',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '10',
      aggValue: 12,
      values: [
        {
          key: 'SCHEDULE',
          value: '6',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '3',
        },
        {
          key: 'CONFIRM',
          value: '3',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '11',
      aggValue: 8,
      values: [
        {
          key: 'SCHEDULE',
          value: '7',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '12',
      aggValue: 10,
      values: [
        {
          key: 'SCHEDULE',
          value: '7',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '3',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '13',
      aggValue: 6,
      values: [
        {
          key: 'SCHEDULE',
          value: '5',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '14',
      aggValue: 10,
      values: [
        {
          key: 'SCHEDULE',
          value: '8',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '2',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '15',
      aggValue: 14,
      values: [
        {
          key: 'SCHEDULE',
          value: '11',
        },
        {
          key: 'RESCHEDULE',
          value: '0',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '2',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '16',
      aggValue: 5,
      values: [
        {
          key: 'SCHEDULE',
          value: '3',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '1',
        },
        {
          key: 'CONFIRM',
          value: '0',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '17',
      aggValue: 4,
      values: [
        {
          key: 'SCHEDULE',
          value: '2',
        },
        {
          key: 'RESCHEDULE',
          value: '1',
        },
        {
          key: 'CANCEL',
          value: '0',
        },
        {
          key: 'CONFIRM',
          value: '1',
        },
        {
          key: 'REQUEST',
          value: '0',
        },
      ],
    },
    {
      name: '18',
      aggValue: 0,
      values: [],
    },
    {
      name: '19',
      aggValue: 0,
      values: [],
    },
    {
      name: '20',
      aggValue: 0,
      values: [],
    },
    {
      name: '21',
      aggValue: 0,
      values: [],
    },
    {
      name: '22',
      aggValue: 0,
      values: [],
    },
    {
      name: '23',
      aggValue: 0,
      values: [],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: '0',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '1',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '2',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '3',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '4',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '5',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '6',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '7',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '8',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '9',
      count: 5,
      total: 8,
      average: 1,
    },
    {
      name: '10',
      count: 7,
      total: 12,
      average: 1,
    },
    {
      name: '11',
      count: 7,
      total: 8,
      average: 1,
    },
    {
      name: '12',
      count: 6,
      total: 10,
      average: 1,
    },
    {
      name: '13',
      count: 5,
      total: 6,
      average: 1,
    },
    {
      name: '14',
      count: 6,
      total: 10,
      average: 1,
    },
    {
      name: '15',
      count: 10,
      total: 14,
      average: 1,
    },
    {
      name: '16',
      count: 5,
      total: 5,
      average: 1,
    },
    {
      name: '17',
      count: 4,
      total: 4,
      average: 1,
    },
    {
      name: '18',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '19',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '20',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '21',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '22',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '23',
      count: 0,
      total: 0,
      average: 0,
    },
  ],
};

export const vairSchedulingOutcomeDummyData = (payload?: any) => {
  if (payload?.filterType === TimeFilterType.DAY_OF_WEEK) {
    return dayOfWeekData;
  }
  if (payload?.filterType === TimeFilterType.HOURLY) {
    return hourlyData;
  }
  return dailyData;
};
